import * as React from "react";
import { ResponsiveBar, Bar, BarSvgProps } from "@nivo/bar";
import Typography from "@material-ui/core/Typography";
import { format, isToday, getMonth, getDate, endOfMonth } from "date-fns";
import { ITransFersPerformedDataCvt } from "../../common/types";

import "../../style/HQDashboard.css";
import Tooltip from "./GroupBarChartTooltip";
import { calcGridYValues } from "./helpers/dashboardHelpers";
import moment from 'moment';
const theme = {
    axis: {
        ticks: {
            text: {
                fill: "#fff",
                fontSize: "12px",
            },
        },
    },
    tooltip: {
        container: {
            background: "#ffffff00",
        },
    },
    legends: {
        text: {
            fill: "#fff",
        },
    },
};

const CustomTick = (tick: any) => {
    return (
        <g transform={`translate(${tick.x - 5},${tick.y + 15})`}>
            <text
                textAnchor="middle"
                dominantBaseline="middle"
                style={{
                    fill: '#ffffff7f',
                    fontSize: 12,
                }}
            >
                {tick.value}
            </text>
        </g>
    )
}

const GroupedBarChart = (props: any) => {
    const maxVal = Math.max(...props.data.map(({ ['Total transfers']: recordCount, ['Pickup time delayed']: pickUpDelayed, ['Transfers delayed']: transferDelayed, ['Aborted']: aborted }: ITransFersPerformedDataCvt) => Math.max(...[recordCount, pickUpDelayed, transferDelayed, aborted])));
    const responsiveGrp = props.data.length <= 20;
    const graphProps: BarSvgProps = {
        data: props.data,
        keys: ["Total transfers", "Pickup time delayed", "Transfers delayed", "Aborted"],
        isInteractive: true,
        indexBy: "date",
        margin: !responsiveGrp ? { top: 70, right: 130, bottom: 70, left: 60 } : { top: 70, right: 50, bottom: 70, left: 30 },
        padding: 0.3,
        groupMode: "grouped",
        theme: theme,
        colors: props.colors,
        borderColor: { from: "color", modifiers: [["darker", 1.6]] },
        axisTop: null,
        axisRight: {
            tickSize: 5,
            tickValues: 3,
            tickPadding: 5,
            tickRotation: 0,
            legend: "",
            legendOffset: 0,
        },
        axisBottom: {
            tickSize:5,         
            tickPadding: 5,
            tickRotation: 0,
            legend: "",
            legendPosition: "end",
            legendOffset: -40,
           // renderTick: CustomTick,         
        },
        axisLeft: null,
        enableLabel: false,
        enableGridX: false,
        enableGridY: true,
        gridYValues: calcGridYValues(maxVal),
        legends: [
            {
                dataFrom: "keys",
                anchor: "bottom",
                direction: "row",
                justify: false,
                translateX: 12,
                translateY: 70,
                itemsSpacing: 15,
                itemWidth: 115,
                itemHeight: 12,
                itemDirection: "left-to-right",
                itemOpacity: 1,
                symbolSize: 10,
                symbolShape: "circle",
                itemTextColor: "#fff",
                effects: [
                    {
                        on: "hover",
                        style: {
                            itemOpacity: 1,
                        },
                    },
                ],
            },
        ],
        animate: true,
        motionStiffness: 90,
        motionDamping: 15,
        tooltip: Tooltip,
    }
    return (
        <>
            <div style={{ marginTop: "48px", marginLeft: "3em" }}>
                <Typography variant="h4">{props.title}</Typography>
            </div>
            <div style={{ height: responsiveGrp ? 220 : "auto", overflowX: "auto", marginLeft: 30, marginRight: 30, paddingBottom: 15 }} id="trf_per_grp_cont">
                {!responsiveGrp ? <Bar {...graphProps} height={220} width={props.data.length * 80} /> : <ResponsiveBar {...graphProps} />}

            </div>
        </>
    );
};

export default GroupedBarChart;
